document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-reel-hover]').forEach(function (card) {
    var video = card.querySelector('.card-reel-video');
    if (!video) return;

    card.addEventListener('mouseenter', function () {
      if (!video.src && video.dataset.src) {
        video.src = video.dataset.src;
      }
      video.style.opacity = '1';
      video.play().catch(function () {});
    });

    card.addEventListener('mouseleave', function () {
      video.pause();
      video.style.opacity = '0';
    });
  });
});
